<template>
<div>
  <div class="ngl" ref="ngl" :style="{position:'relative',marginLeft:'0px',marginTop:'0px',width:'100%',height:`${style.height}px`}">
    <div :style="dragBoxStyle" v-if="dragBottomRight"></div>

    <div class="viewport-panel" ref="viewportPanel">
      <!-- Picking Menu -->
      <div class="popup-menu" :style="contextMenuStyle">
        <div class="menu-head">
          <div class="menu-title">{{clickedResidue}}</div>
          <div class="menu-close" @click="contextMenuStyle.display='none'"><i class="el-icon-close"></i></div>
        </div>
        <div class="menu-body">
          <!--
          <div class="menu-row">select atom</div>
          -->
          <div class="menu-row" @click="onClickPickLeft(store.stage, lastClick)">select residue</div>
          <!--
          <div class="menu-row">select chain</div>
          -->
        </div>
      </div>

      <!-- Viewport Sequence -->
      <div ref="viewportSequence">
        <ngl-sequence :store="store" v-if="sequenceVisible" @toggle="toggleSelection"></ngl-sequence>
      </div>

      <div ref="viewport" :style="{height:`${style.viewportHeight}px`,width:'100%'}"></div>

      <div class="viewport-bottom" ref="viewportBottom" :style="{height:`${style.cmdHeight}px`}">

        <div class="file-button-box">
          <div class="file-button" @click="fileMenuVisible=!fileMenuVisible">File</div>

          <div class="popup-menu" v-if="fileMenuVisible">
            <div class="menu-head">
              <div class="menu-title">File</div>
              <div class="menu-close" @click="fileMenuVisible=false"><i class="el-icon-close"></i></div>
            </div>
            <div class="menu-body">
              <div class="menu-row" @click="fileMenuVisible=false;$refs.fileOpen.click()">
                open
                <input type="file" ref="fileOpen" hidden @change="load($event.target.files[0])">
              </div>
              <!--
              <div class="menu-row">save</div>
              -->
              <div class="menu-row">
                export
                <div class="menu-submenu">
                  <div v-for="(obj,iobj) in store.structureObjects" @click="obj.export();fileMenuVisible=false" class="menu-row" :key="iobj">
                    {{ obj.name }}
                  </div>
                </div>
              </div>

              <div class="menu-row" @click="screenShot();fileMenuVisible=false">
                snapshot
              </div>
            </div>
          </div>
        </div>

        <div class="cmd-label" @click="cmdResultVisible=!cmdResultVisible">
          Command <i class="el-icon-d-arrow-left" :style="{transform: (cmdResultVisible?'rotate(-90deg)':'rotate(90deg)')}"></i>
        </div>

        <div class="cmd-box">
          <input class="cmd-input" type="text" v-model="cmd" @keyup.enter="runCmd" @keyup.up="lastCmd" @keyup.down="nextCmd" :style="{height:`${style.cmdHeight}px`,width:'100%',marginTop:'0px'}">
          <div ref="cmdResultPanel" class="cmd-result-panel" v-show="cmdResultVisible">
            <div ref="cmdResultPanelContent" style="width:90%">
              <div v-html="cmdResult"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="controlPanel" style="height:100%" v-if="store">
      <ngl-control :store="store" :objectNameWidth="objectNameWidth" @object:delete="store.deleteObjectById($event)" @toggle:sequence="sequenceVisible=!sequenceVisible" @toggle:fullscreen="toggleFullscreen" @drag:left="dragLeft=true" @drag:bottom-right="onDragBottomRight" @toggle:selection="$emit('toggle:selection')"></ngl-control>
    </div>

  </div>
</div>
</template>

<script>
import * as NGL from 'ngl'
import CoffeeScript from 'coffeescript'
import { Vector3, Matrix4 } from 'three'

export default {
  name: 'NglView',

  data () {
    let v = this
    return {
      store: '',

      style: {
        height: (v.height ? v.height : 400),
        cmdHeight: 19,
        viewportHeight: (v.height ? v.height - 20 : 380),
        viewportWidth: 400
      },

      contextMenuStyle: {
        display: 'none',
        position: 'absolute',
        zIndex: 200,
        width: '150px'
      },

      clickedResidue: '',
      fileMenuVisible: false,
      lastClick: '',

      clickLevels: ['atom', 'residue', 'chain'],
      clickLevel: 'residue',
      sequenceVisible: false,

      cmd: '',
      cmdResult: `Initialization...<br>Please type 'do help' for more information.<br>`,
      cmdResultVisible: false,
      cmdCall: {},
      cmdPending: true,

      fullscreen: false,
      dragLeft: false,
      dragBottomRight: false,
      objectNameWidth: 120,
      lastMouse: [0, 0],
      dragWidth: 0,
      dragheight: 0
    }
  },

  components: {
    NglSequence: () => import('./NglSequence.vue'),
    NglControl: () => import('./NglControl.vue')
  },

  props: [ 'height', 'nameWidth', 'pdb', 'id' ],

  computed: {
    objects () {
      return this.store.objects
    },

    sele () {
      return this.store.sele
    },

    dragBoxStyle () {
      let v = this
      return {
        position: 'absolute',
        left: 0,
        top: 0,
        width: `${v.dragWidth}px`,
        height: `${v.dragHeight}px`,
        borderRight: '1px dotted grey',
        borderBottom: '1px dotted grey',
        zIndex: 999
      }
    }
  },

  methods: {
    onDragBottomRight (x, y) {
      this.dragBottomRight = true
      this.lastMouse = [x, y]
    },

    toggleFullscreen () {
      let ngl = this.$refs.ngl
      if (this.fullscreen) {
        this.fullscreen = false

        ngl.style.width = `${this.oldRect.width}px`
        ngl.style.height = `${this.oldRect.height}px`
        document.body.style.overflowY = 'auto'

        Object.assign(ngl.style, {
          position: 'relative'
        })
      } else {
//        console.log(window.innerHeight)
        this.fullscreen = true

        this.oldRect = ngl.getClientRects()[0]

//        this.style.oldHeight = this.style.height
//        this.style.height = window.innerHeight

        ngl.style.width = `${window.innerWidth}px`
        ngl.style.height = `${window.innerHeight}px`
        document.body.style.overflowY = 'hidden'

        Object.assign(ngl.style, {
          position: 'fixed',
          left: 0,
          top: 0
        })
      }
    },

    runCmd () {
      this.nglRepl.emit('run', this.cmd)
      this.cmd = ''
    },

    lastCmd () {
//      console.log('lastCmd')
      this.cmd = this.nglRepl.lastCommand()
    },

    nextCmd () {
//      console.log('nextCmd')
      this.cmd = this.nglRepl.nextCommand()
    },

    toggleSelection (selections) {
      let v = this

      for (let selection of selections) {
        let obj = selection.object
        let residue = selection.residue

        if (!v.store.currentSelection) {
          if (v.store.sele) {
            v.store.sele.visible = true
            v.store.sele.selections = [new NGL.Selection(`${residue.resno}:${residue.chainname}`)]
            v.store.sele.components = [obj.components[0]]
          } else {
            this.store.objects.push(this.store.makeObject('sele', 'selection', [obj.components[0]], [new NGL.Selection(`${residue.resno}:${residue.chainname}`)]))
            v.store.sele.visible = true
          }
        } else {
          let ind = v.store.currentSelection.components.findIndex(comp => comp === obj.components[0])
          if (ind !== -1) {
            let sele = v.store.currentSelection.selections[ind]
            let str = sele.string
            if (residue.active) {
              sele.setString(`(${str}) and (not (${residue.resno}:${residue.chainname}))`)
            } else {
              sele.setString(`(${str}) or (${residue.resno}:${residue.chainname})`)
            }
          } else {
            v.store.currentSelection.components.push(obj.components[0])
            if (residue.active) {
              v.store.currentSelection.selections.push(new NGL.Selection(`not (${residue.resno}:${residue.chainname})`))
            } else {
              v.store.currentSelection.selections.push(new NGL.Selection(`${residue.resno}:${residue.chainname}`))
            }
          }
        }
      }

      v.store.currentSelection.updateSelection()

      v.$emit('update:selection')
    },

    resetAction (str, callback) {
      let v = this
//      console.log(`reset ${str}...`)
      v.store.stage.mouseControls.remove(str)
      v.store.stage.mouseControls.add(str, callback)
    },

    onClickRight (stage, x, y) {
      var v = this

      v.contextMenuStyle.display = 'none'

      var pickingProxy = stage.pickingControls.pick(x, y)
      if (pickingProxy && (pickingProxy.atom || pickingProxy.bond)) {
        var atom = pickingProxy.atom || pickingProxy.closestBondAtom
        let comp = pickingProxy.component
        let obj = v.store.getObjectByComponent(comp)
        var mp = pickingProxy.mouse.position
        v.clickedResidue = `${obj.name} ${atom.chainname}-${atom.resno}[${atom.resname}]`
//        let offset = document.querySelector('.viewport-panel').getBoundingClientRect()
        let offset = v.$refs.viewportPanel.getBoundingClientRect()
        v.contextMenuStyle.top = `${mp.y + 3 - offset.top}px`
        v.contextMenuStyle.left = `${mp.x + 10 - offset.left}px`
        v.contextMenuStyle.display = 'block'
      } else {
        v.contextMenuStyle.display = 'none'
      }

      v.lastClick = pickingProxy
    },

    onClickPickLeft (stage, pickingProxy) {
      let v = this
      v.contextMenuStyle.display = 'none'

//      let pickingProxy = stage.pickingControls.pick(x, y)
      if (pickingProxy && (pickingProxy.atom || pickingProxy.bond)) {
        let atom = pickingProxy.atom || pickingProxy.closestBondAtom
        var str
        var proxy
        if (v.clickLevel === 'atom') {
          str = `${atom.resno}:${atom.chainname}.${atom.atomname}/${atom.modelIndex}`
          proxy = atom
        } else if (v.clickLevel === 'residue') {
          str = `${atom.resno}:${atom.chainname}/${atom.modelIndex}`
          proxy = atom.residue
        } else if (v.clickLevel === 'chain') {
          str = `:${atom.chainname}/${atom.modelIndex}`
          proxy = atom.residue.chain
        }

        if (!v.store.currentSelection) {
          if (v.store.sele) {
            v.store.sele.visible = true
            v.store.sele.selections = [new NGL.Selection(str)]
            v.store.sele.components = [pickingProxy.component]
          } else {
            this.store.objects.push(this.store.makeObject('sele', 'selection', [pickingProxy.component], [new NGL.Selection(str)]))
            v.store.sele.visible = true
          }
        } else {
          let i = v.store.currentSelection.components.findIndex(comp => comp === pickingProxy.component)
          if (i === -1) {
            v.store.currentSelection.components.push(pickingProxy.component)
            v.store.currentSelection.selections.push(new NGL.Selection(str))
          } else {
            let sele = v.store.currentSelection.selections[i]
//            console.log(v.store.currentSelection)
            if (sele.test && sele.test(proxy)) {
//              console.log('pass the test')
              sele.setString(`(${sele.string}) and (not (${str}))`)
            } else {
//              console.log('fail the test')
//              console.log(sele.string)
              sele.setString(`(${sele.string}) or (${str})`)
//              console.log(sele.string)
            }
          }
        }
        v.store.currentSelection.updateSelection()
      } else {
        if (v.store.currentSelection) {
          v.store.currentSelection.hide()
        }
      }

      v.lastClick = pickingProxy
    },

    initActions () {
      let v = this

      v.resetAction('hoverPick', () => {})

      v.resetAction('clickPick-left', (stage, pick) => {
        v.onClickPickLeft(stage, pick)
      })

      v.resetAction('click-right', (stage, x, y) => {
        v.onClickRight(stage, x, y)
      })

      v.resetAction('drag-middle-shift', (stage, x, y) => {
        v.panComponentXY(stage, x, y)
      })

      v.resetAction('drag-right-shift', (stage, x, y) => {
        v.panComponentZ(stage, x, y)
      })
    },

    panComponentZ (stage, x, y) {
      const tmpPanMatrix = new Matrix4()
      const tmpPanVector = new Vector3()

      let t = stage.trackballControls

      let r = Math.sqrt(x * x + y * y)
      r = (y > 0 ? r : -r)
      const scaleFactor = t.controls.getCanvasScaleFactor(0)
      tmpPanVector.set(0, 0, r)
      tmpPanVector.multiplyScalar(scaleFactor)

      tmpPanMatrix.extractRotation(t.component.transform)
      tmpPanMatrix.premultiply(t.viewer.rotationGroup.matrix)
      tmpPanMatrix.getInverse(tmpPanMatrix)
      tmpPanVector.applyMatrix4(tmpPanMatrix)

      t.component.position.add(tmpPanVector)
      t.component.updateMatrix()
    },

    panComponentXY (stage, x, y) {
      const tmpPanMatrix = new Matrix4()
      const tmpPanVector = new Vector3()

      let t = stage.trackballControls

      const scaleFactor = t.controls.getCanvasScaleFactor(0)
      tmpPanVector.set(x, y, 0)
      tmpPanVector.multiplyScalar(scaleFactor)

      tmpPanMatrix.extractRotation(t.component.transform)
      tmpPanMatrix.premultiply(t.viewer.rotationGroup.matrix)
      tmpPanMatrix.getInverse(tmpPanMatrix)
      tmpPanVector.applyMatrix4(tmpPanMatrix)

      t.component.position.add(tmpPanVector)
      t.component.updateMatrix()
    },

    load (s, params = {}) {
      let v = this
      return new Promise((resolve, reject) => {
        v.init.then(() => {
          var name
          if ('File' in window && s instanceof File) {
            name = s.name
            let found = name.match(/^(.+)\.([^.]+)$/)
            if (found) {
              name = found[1]
              if (!('ext' in params)) {
                params.ext = 'pdb'
              }
            } else {
    //          console.log(`Not found ${name}!`)
              return
            }
          } else if ('Blob' in window && s instanceof Blob) {
            name = `obj${this.store.objects.length}`
            if (!('ext' in params)) {
              params.ext = 'pdb'
            }
          } else if (typeof s === 'string' || s instanceof String) {
            name = s
            let found = s.match(/^rcsb:\/\/(.+)$/)
    //        console.log('found')
    //        console.log(found)
            if (found) {
              name = found[1]
            } else {
    //          console.log(`Not found ${name}!`)
              return
            }
          }

          v.store.stage.loadFile(s, params).then(function (comp) {
            let obj = v.store.makeObject(name, 'structure-component', [comp], [new NGL.Selection('all')])
  //          console.log(`Loaded ${s}`)
            v.store.objects.push(obj)
            obj.showRepresentation('cartoon')
            comp.autoView()
            resolve(obj)
          })
        })
      })
    },

    checkSize () {
      let v = this

      let nglEl = v.$refs.ngl
      let viewEl = v.$refs.viewportPanel
      let ctlEl = v.$refs.controlPanel

      let seqEl = v.$refs.viewportSequence
      let viewportEl = v.$refs.viewport
      let btmEl = v.$refs.viewportBottom

      if (nglEl && viewEl && ctlEl) {
        let height = nglEl.offsetHeight - seqEl.offsetHeight - btmEl.offsetHeight - 2
        let width = nglEl.offsetWidth - ctlEl.offsetWidth

        viewEl.style.width = `${width}px`
        viewportEl.style.height = `${height}px`
        v.store.stage.viewer.setSize(width, height)
      }
    },

    screenShot () {
      var v = this
      v.store.stage.makeImage({
        factor: 5
//        antialias: antialiasCheckbox.getValue(),
//        trim: trimCheckbox.getValue(),
//        transparent: transparentCheckbox.getValue(),
//        onProgress: onProgress
      }).then(function (blob) {
        NGL.download(blob, 'ngl-screenshot.png')
      })
    }
  },

  mounted () {
    let v = this

    v.$nextTick(function () {
//      console.log(11)
      let id = v.id
      if (!id) {
        id = Math.floor(Math.random() * 1000000)
      }
      v.init = v.$store.dispatch('ngl/newInstance', {
        el: v.$refs.viewport,
        id: v.id,
        par: {
          backgroundColor: 'white'
        }
      }).then((instance, id) => {
//        console.log(22)
        v.store = instance
        v.storeId = id

        v.$nextTick(() => {
          if (v.pdb) {
            v.load(v.pdb)
          }

          v.store.stage.mouseControls.preset('pymol')
          v.initActions()

          v.nglRepl = new window.NglRepl(CoffeeScript.compile, v, v.store.stage, v.objects)

          v.nglRepl.start()

          v.nglRepl.on('update', function (result) {
            v.cmdResult = result
          })

          v.checkSize()

          window.ResizeSensor(v.$refs.viewportPanel, function () {
            v.checkSize()
          })

          window.ResizeSensor(v.$refs.controlPanel, function () {
            v.checkSize()
          })

          window.ResizeSensor(v.$refs.ngl, function () {
            v.checkSize()
          })

          window.ResizeSensor(v.$refs.cmdResultPanelContent, function () {
            let panel = v.$refs.cmdResultPanel
            let content = v.$refs.cmdResultPanelContent
            panel.scrollTop = content.scrollHeight - panel.clientHeight
          })

          v.mouseupListener = function (e) {
            v.dragLeft = false
            if (v.dragBottomRight) {
    //          console.log('ngl-mouse-move')
              let ngl = v.$refs.ngl
    //          console.log(`offsetWidth: ${ngl.offsetWidth}, offsetHeight: ${ngl.offsetHeight}, movementX: ${e.movementX}, movementY: ${e.movementY}`)
              ngl.style.width = `${ngl.offsetWidth + e.clientX - v.lastMouse[0]}px`
              ngl.style.height = `${ngl.offsetHeight + e.clientY - v.lastMouse[1]}px`
            }
            v.dragBottomRight = false
          }

          v.mousemoveListener = function (e) {
            if (v.dragLeft) {
              v.objectNameWidth -= e.movementX
            }
            if (v.dragBottomRight) {
              let ngl = v.$refs.ngl
              let rect = ngl.getClientRects()[0]
              v.dragWidth = e.clientX - rect.x
              v.dragHeight = e.clientY - rect.y
    //          console.log(`width:${v.dragWidth} height:${v.dragHeight}`)
            }
          }

          window.addEventListener('mouseup', v.mouseupListener)

          window.addEventListener('mousemove', v.mousemoveListener)

          v.$emit('init')

//          console.log('init')
        })
      })
    })
  },

  destroyed () {
    let v = this

    window.removeEventListener('mouseup', v.mouseupListener)

    window.removeEventListener('mousemove', v.mousemoveListener)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../styles/theme.scss";


$line-color: #eeeeee;

.ngl {
  border: 1px solid $line-color;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  font-size: 11px;
  margin: auto auto;
  background-color: white;
  z-index: 200;
  position: relative;
}

.viewport-panel {
  border-right: 1px solid $line-color;
  position: relative;
}

.viewport-bottom {
  margin: auto 0px 0px 0px;
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 600;
  color: $font-grey;
  background-color: #dddddd;
  border-top: 1px solid $line-color;
}

.file-button-box {
  border-right: 1px solid $line-color;
  cursor: pointer;
  position: relative;
}

.file-button:hover {
  opacity: 0.5;
}

.file-button {
  width: 100%;
  height: 100%;
  padding: 0px 20px;
}

.cmd-label {
  padding: 0px 20px;
  white-space: nowrap;
  cursor: pointer;
}

.cmd-box {
  margin-right: 0px;
  margin-left: 0px;
  width: 100%;
  position: relative;
}

.cmd-input {
  border: none;
  outline: none;
  margin: 0px;
  margin-top: -1px;
  padding: 0px;
}

.cmd-input:focus {
  outline: none;
}

.file-button-box .popup-menu {
  bottom: 100%;
  left: 0;
  right: auto;
}

.cmd-result-panel {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  padding: 10px;
  min-height: 150px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  max-height: 200px;
  overflow-y: auto;
}

</style>
